// NOTE: native
import React from 'react'
import ReactDOM from 'react-dom/client'
// NOTE: hooks
import { BrowserRouter } from 'react-router-dom'
import { AuthContextProvider } from './context/AuthContext'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
// NOTE: components
import App from './App'
import Toaster from './components/ui/Sonner'
// NOTE: assets
import './assets/css/index.css'
// NOTE: Sentry initialization
import './sentry'

const queryClient = new QueryClient()

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement)
root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <AuthContextProvider>
        <Toaster closeButton richColors />
        <BrowserRouter future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
          <App />
        </BrowserRouter>
      </AuthContextProvider>
    </QueryClientProvider>
  </React.StrictMode>
)
